module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10045.5645f9dc.jpg";